import { appLink, registerRouteRedirectGuard } from '@experience/core-app-link-lib';
import { initWebComponent } from '@experience/vite-plugin-wc-extract-styles';
import { createHead } from '@unhead/vue/client';
import { createPinia } from 'pinia';
import { defineCustomElement } from 'vue';
import { createWebHistory, createRouter, createRouterMatcher } from 'vue-router';
import { QueryClient, VueQueryPlugin } from '@tanstack/vue-query';

import App from '@/App.ce.vue';
import { defaultRoutes } from '@/router';
import { MF_NAME } from '@/const';
import { createI18n } from '@experience/i18n';

const matcher = createRouterMatcher(defaultRoutes, {});
// нужно для локального запуска МФ
// TODO: убрать при обновлении шаблона
const getDevStylesUrl = () => {
  const moduleUrl = new URL(import.meta.url);
  const url =
    moduleUrl.origin === window.location.origin
      ? moduleUrl
      : new URL(`/mfs/${MF_NAME}/extracted-styles.css`, window.location.origin);

  url.pathname =
    moduleUrl.origin === window.location.origin ? '/extracted-styles.css' : `/mfs/${MF_NAME}/extracted-styles.css`;
  url.search = '';
  url.hash = '';

  return url;
};

const stylesUrl = import.meta.env.DEV
  ? getDevStylesUrl()
  : new URL(`${window.location.protocol}//${window.location.host}/remote_${MF_NAME}/extracted-styles.css`);

export default initWebComponent({
  elementName: MF_NAME, // Will be replaced with the actual MF_NAME from const.ts
  stylesUrl,
  dev: import.meta.env.DEV,

  defineElement: (styles) =>
    defineCustomElement(App, {
      styles,
      configureApp(app) {
        // префикс пустой: на страницах хоста путь эндпоинта редиректов проксируется как есть
        app.use(appLink({ matcher, hostAppRouterName: '__HOST_APP_ROUTER__', redirectApiPrefix: '' }));
        app.use(createPinia());
        app.use(createHead());

        const router = createRouter({
          history: createWebHistory('/guide/'),
          routes: defaultRoutes,
        });

        const i18n = createI18n({
          legacy: false,
          locale: 'ru',
        });
        app.use(i18n);

        const queryClient = new QueryClient({
          defaultOptions: {
            queries: {
              staleTime: 1000 * 60 * 3, // 3 минуты
            },
          },
        });
        app.use(VueQueryPlugin, { queryClient });
        registerRouteRedirectGuard(router);

        app.use(router);
      },
    }),
});
